<template>
<div class="stratigraphy">
	<div class="modal-window">
		<div class="modal-content">
			<grid>
				<div alt="logo" class="logo" />
			</grid>
			<grid>
				<grid-item size="1/1">
					<h3>Newly registered companies and jobs created against time</h3>
				</grid-item>
			</grid>
			<grid>
				<grid-item size="1/1">
					<img class="stratigraphy-image" src="@/assets/images/stratigraphy.png" alt="stratigraphi">
				</grid-item>
			</grid>
			<hr>
			<button class="button primary" @click="goToOpportunity()">
				close
			</button>
		</div>
	</div>
	<a @click="goToOpportunity()" class="back-button">
		X
	</a>
</div>
</template>

<script>
export default {
	methods: {
		goToOpportunity() {
			this.$router.push({
				name: 'opportunity',
				hash: '#StraitigraphyTab',
				params: {
					opportunityId: this.$route.query.opportunityId
				},
				query: {
					...this.$route.query,
					opportunityId: undefined
				}
			})
		}
	}
}
</script>

<style lang="scss">
.stratigraphy {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 56px;
	right: 0;
	z-index: 3;
	background: #0202029c;

	.modal-window {
		top: 48% !important;
		left: 48% !important;
		width: 40% !important;
		
		h3 {
			color: #fff;
			font-size: 13px;
			text-transform: uppercase;
		}
		.modal-content {
			background: linear-gradient(to left, rgba(4, 4, 4, 0.51), rgba(50, 67, 80, 0.52));
			padding-bottom: 15px;
			padding-top: 10px;
			border-color: rgba(255, 255, 255, 0.19);
		}
		.logo {
			margin: 0 auto;
		}
		.stratigraphy-image {
			width: 100%;
		}
		hr {
			margin: 15px;
			width: 520px;
			margin-left: -40px;
		}
		.button {
			width: 150px;
			padding: 4px 13px;
			margin: 4px 0px;
		}
	}

	.back-button {
		position: absolute;
		top: 0;
		right: 0;
		text-decoration: none;
		color: #fff;
		background: #3b9fcf;
		width: 55px;
		height: 55px;
		line-height: 55px;
		font-size: 32px;
		font-weight: 200;
		cursor: pointer;
	}
}
</style>
